const endPoint = {
  login: "login",
  forgotPassword: "user/forget-password",
  resetPassword: "user/reset-password",
  user: "users",
  approveUser: "users/",
  createUser: "users/create",
  addPropertyOwner: "user/property-owner/create",
  updatePropertyOwner: "user/property-owner/",
  brands: "brands",
  propertyOwner: "user/property-owner",
  store: "store/",
  createBrand: "brands/create",
  updateBrand: "/brands/",
  createStore: "store/create",
  warehouse: "warehouse/",
  warehouseCreate: "warehouse/create",
  products: "products/",
  approveProduct: "products/approve/",
  rejectProduct: "products/reject/",

  createProducts: "products/create",
  category: "category/",
  createCategory: "category/create",
  fileUpload: "files/upload",
  createBrandManager: "user/brand-manager/create",
  brandApprove: "brands/approve/",
  brandManagerApprove: "user/brand-manager/approve/",
  brandOwner: "user/brand-manager",
  oprationManager: "user/operations-manager",
  createOprationManager: "user/operations-manager/create",
  biller: "user/biller",

  createBiller: "user/biller/create",
  warehouseStock: "warehouse-stocks",
  createWarehouseStock: "warehouse-stocks/create",
  warehouseById: "warehouse-stocks/warehouse/",
  storeStock: "store-stocks",
  createStoreStock: "store-stocks/create",
  storeStockInvoice: "store-stocks/invoice/",
  w2s: "w2s-stocks",
  w2w: "w2w-stocks/",
  s2w: "s2w-stocks/",
  s2s: "s2s-stocks/",
  customers: "customers/",
  storeGRN: "GRN/store/",
  warehouseGRN: "GRN/warehouse/",
  GRN: "GRN/",
  createGRN: "GRN/create",
  grnInvoice: "GRN/invoice-numbers/",
  SKUTimeline: "sku-timelines",
  sku: "sku",
  skuDetail: "sku/details",
  SKUTimelineSpecific: "sku-timelines/specific",
  createW2S: "w2s-stocks/create",
  createS2W: "s2w-stocks/create",
  createW2W: "w2w-stocks/create",
  createS2S: "s2s-stocks/create",
  deleteGrn: "GRN/delete/",
  rtvStoreStock: "rtvstore-stocks/store",
  rtvStoreWarehouse: "rtvstore-stocks/warehouse",
  createRtv: "rtvstore-stocks/create",
  orderCreate: "orders/create",
  orders: "orders",
  runnerAsign: "/runner/",
  orderReturn: "orderReturn/",
  createPo: "po/create",
  PO: "po/store/",
  POSingle: "po/singleStoreOrder/",
  deletePo: "po/",
  // KAN-519 — PUT /po/:id (edit a PO before it's paid)
  updatePo: "po/",
  b2bDashboardMetrics: "b2b/dashboard/metrics",
  appVersion: "appVersion",
  appVersionForDashboard: "appVersionForDashboard",
  banners: "banners",
  dashboard: "users/dashboard",
  orderInvoice: "orders/invoice/",
  updateStatusW2S: "w2s-stocks/updateStatus/",
  updateStatusW2W: "w2w-stocks/updateStatus/",
  updateStatusS2S: "s2s-stocks/updateStatus/",
  updateStatusS2W: "s2w-stocks/updateStatus/",
  w2sPdf: "w2s-stocks/pdf/",
  w2wPdf: "w2w-stocks/pdf/",
  s2sPdf: "s2s-stocks/pdf/",
  s2wPdf: "s2w-stocks/pdf/",
  updateQuantityS2w: "s2w-stocks/updateProductQuantity/",
  updateQuantityW2w: "w2w-stocks/updateProductQuantity/",
  updateQuantityW2s: "w2s-stocks/updateProductQuantity/",
  updateQuantityS2s: "s2s-stocks/updateProductQuantity/",
  allReturns: "orderReturn/allReturns",
  poWarehouse: "po/warehouse",
  sigleWarehousePo: "po/singleWarehouseOrder/",
  verifyRtv: "rtvstore-stocks/verify/",
  returnPdf: "orderReturn/pdf/",
  updateStoreStock: "store-stocks/updateStock",
  updateWarehouseStock: "warehouse-stocks/updateStock",
  cashPendingReport: "store/cashPending-report",
  cashout: "cashOut",
  getOrderById: "orders/list/",
  orderStatusUpdate: "orders/status/",
  rtvStoreStockPdf: "rtvstore-stocks/pdf/",
  updateRazorToken: "orders/savePaymentToken",
  cancelOrder: "orderReturn/cancel-order/",
  orderCSVReport: "orders/orderReportCSV",
  updateSellingAndCostPrice: "store-stocks/updateStockPrice",
  RTVStoreStockReport: "rtvstore-stocks/RTVreport",
  GRNStoreReport: "GRN/GRNreportStore",
  GRNWarehouseReport: "GRN/GRNreportWarehouse",
  // dahboard: "/users/dashboard",
  dailyStockReport: "store-stocks/dailyReport",
  grnBulkUpload: "GRN/upload/",
  changeUserPassword: "users/password/",
  discardReports: "rtvstore-stocks/discardReport",
  currentStock: "store-stocks/report/storeStocksCSV",
  returnReport: "orderReturn/report/returncsv",
  productsForDropdown: "products/store/stocks",
  recipes: "recipes",
  createRecipes: "recipes/create",
  // addIngredient: "/recipes/createRecipeIngredient",
  razorPayOrder: "store/razorPay",
  storeRoyalty: "store/royalty",
  royaltyDetail: "store/royalty/detailed/",
  addIngredient: "recipes/createRecipeIngredient",
  refreshToken: "refresh-token",
  logout: "logout",
  // addIngredient: "/recipes/createRecipeIngredient",
  credit: "credit",
  creditReport: "credit/creditListReportStore",
  cashPendingEdit: "store/cashPendingEdit/",
  cashin: "cashIn",

  trends: "store/trends/",
  chanelDashboard: "store/channelDataDashboard/",
  topPerformingProduct: "store/topPerformingProducts/",
  topPerformingCategory: "store/topPerformingCategories/",
  inventories: "store/inventories/",
  deadInventories: "store/deadinventories/",
  deadInventoryReports: "store/deadInventoryReportStore/",
  outOfStock: "store/outofstock/",
  discadValue: "store/discardValues/",
  outOfStockReport: "store/OutOfStockReportCSV/",
  GSTR: "store/combined/",
  dailyReport: "reports/daily-stock",
  deadInventoriesCSV: "store/deadInventoryReportStore/",
  outOfStockCSV: "store/OutOfStockReportCSV/",
  vpsProducts: "vps/product/",
  b2bProduct: "vps/b2bproduct",
  brandManagerPincode: "user/brand-manager/pincodes/",
  vendorPOHistory: "vps/vendor-history/",
  // KAN-516 — outbound vendor payment (New Shop -> vendor). Distinct from
  // the older `vendorPOHistory + "utr"` endpoint, which is the inbound leg
  // (store -> New Shop, lands in proofOfPayment) — do not conflate the two.
  vendorUtrRecord: "vps/vendor-history/", // + id + "/vendor-utr"
  vendorUtrVerify: "vps/vendor-history/", // + id + "/vendor-utr/verify"
  vendorOrderComplete: "vps/vendor-history/", // + id + "/complete"

  blobUpload: "azureblob/upload",
  shiftReport: "shift/ShiftReportCSV/",
  filePincodeUpdate: "user/brand-manager/upload",
  b2bVendor: "b2bVendors/order",
  detailInvoice: "b2bVendors/b2bproduct/",
  b2bReport: "reports/b2b-report",
  invoicePdf: "invoice/pdf",
  invoice: "invoice",
  createInvoice: "invoice/create",
  invoiceAttempt: "invoice/attempt",
  invoiceRetry: "invoice/retry",
  storePdfInvoice: "invoice/store/pdf",
  manualEinvoice: "manual-einvoices",
  topProductCSV: "store/topPerformingProductsReportCSV/",
  topCategoryCSV: "store/topPerformingCategoriesReportCSV/",
  checkBarcode: "products/check-barcode",
  paymentList: "payment/list",
  paymentStatus: "payment/status",
  zohoPaymentSession: "zoho/payment/session",
  zohoPaymentSessionById: "zoho/payment/session/",
  zohoPaymentLink: "zoho/payment/link",
  storeMinQty: "store/minqty/",
  stockLedger: "store-stocks/stockLedgerCSV",
  uploadVendorProduct: "vps/upload",
  uploadB2bProduct: "vps/b2bproduct/upload",
  vendorProducts: "vps/v2p/product/list",
  vendorProduuctUpdate: "vps/v2product/",

  announcements: "announcements",
  uploadFile: "azureblob/upload-file",
  bpApplications: "bp-portal/applications",
  advertisements: "advertisements",
  adPurchases: "advertisements/purchases",
  coupon: "coupons/",
  vendorStores: "b2b/vendor-stores",
  vendorStoresBulk: "b2b/vendor-stores/bulk",
  b2bWalletReport: "b2b/wallet/report",
  b2bWalletReportCSV: "b2b/wallet/report/csv",
  // KAN-559: the store owner's Advance / Credit (+ storeId) and a PO's
  // ledger rows (vps/vendor-history/ + po.id + /wallet).
  b2bWalletByStore: "b2b/wallet/store/",
  // KAN-564/565: top-up (b2b/wallet/ + userId + /topup), reversal
  // (+ txnId + /reverse) and skipped credits (+ /:id/resolve).
  b2bWallet: "b2b/wallet/",
  b2bWalletTransactions: "b2b/wallet/transactions/",
  b2bWalletSkipped: "b2b/wallet/skipped-credits",
  createCustomer: "customers/create",
  b2bCashback: "b2b-cashback",
  b2bCashbackBulk: "b2b-cashback/bulk",
  tasks: "tasks",
  tasksReview: "tasks/review",
  tasksAnalytics: "tasks/analytics",
  taskTemplates: "tasks/templates",

  b2bBrandBanner: "b2b/brand-banner",
  b2bBrandBannerById: "b2b/brand-banner/",
  b2bBrandBannerByBrand: "b2b/brand-banner/brand/",
  notifications: "notifications",
  notificationsUnreadCount: "notifications/unread-count",
  notificationRead: "notifications/",
  notificationReadAll: "notifications/read-all",
  notificationDeviceToken: "notifications/device-token",
  notificationTest: "notifications/test",
  aiGrnJobs: "ai-grn/jobs",
  aiGrnUpload: "ai-grn/upload",
  aiGrnBulkUpload: "ai-grn/bulk-upload",
  // Cash handover: list / create, + "/:id", "/:id/challan", "/:id/review".
  cashHandover: "cash-handover",
  aiGrnApprovalRequests: "ai-grn/approval-requests",
  // Expenses (+ "/:id") and parcel tracking (+ "/:id", "/:id/status").
  expenses: "expenses",
  parcelTracking: "parcel-tracking",
  // Private files: upload → blob URL; view?url= → 15-min { signedUrl }.
  privateFileUpload: "files/upload",
  privateFileView: "file/view",
};
export default endPoint;
